import React, { useState } from "react";

import { Box, Button, Paper, Stack } from "@mui/material";
import { PageHeaderMui } from "../../components/index.js";
import { ShieldPersonIcon } from "../../components/mui/index.js";
import { useNavigate } from "react-router-dom";

export const BillingLanding = () => {
  const Navigate = useNavigate();
  const [loading] = useState(true);

  return (
    <>
      <div
        className="wrapper"
        style={{ height: !!loading.length ? "100vh" : "auto" }}
      >
        <PageHeaderMui
          type="Billing Landing Page"
          icon={<ShieldPersonIcon />}
        />
        <Stack spacing={2}>
          <Box sx={{ px: "20px", pt: "20px", width: "fit-content" }}></Box>
          <Paper sx={{}}>
            <Stack sx={{ p: "20px" }} spacing={2}>
              <Box sx={{ py: "30px" }}> Billing Landing page</Box>

              <Button
                onClick={(e) => {
                  Navigate("/billing/quickbooks-customer-list");
                }}
                disabled
                variant="contained"
                sx={{ width: "fit-content" }}
              >
                Quickbooks Customer List (Not ready yet)
              </Button>

              <Button
                onClick={(e) => {
                  Navigate("/billing/quickbooks-invoice-list");
                }}
                variant="contained"
                sx={{ width: "fit-content" }}
              >
                Quickbooks Invoice Automation
              </Button>

              <Button
                onClick={(e) => {
                  Navigate("/billing/quickbooks-mailer-invoice-list");
                }}
                variant="contained"
                sx={{ width: "fit-content" }}
              >
                Quickbooks Mailer Invoice Automation
              </Button>
            </Stack>
          </Paper>
        </Stack>
      </div>
    </>
  );
};
